import { Button, Card, Input, TableProps, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import CloseIcon from "../../../../assets/icons/CloseIcon";
import DoubleCheckIcon from "../../../../assets/icons/DoubleCheckIcon";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import ConfirmActionModal from "../../../../components/Businesses/ConfirmActionModal";
import SuccessModal from "../../../../components/common/SuccessModal";
import CustomTable from "../../../../components/ui/CustomTable";
import Loader from "../../../../components/ui/Loader";
import {
  useGetAllBatchPendingListQuery,
  usePendingBatchBulkActionMutation,
} from "../../../../features/portal/batch/batchApi";
import { useGetSingleUserWalletRoleQuery } from "../../../../features/portal/companyOnboard/companyOnboardApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import ConfirmModalLayout from "../../../../layouts/ConfirmModalLayout";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatDate, formatTime } from "../../../../lib/time";
import {
  GetAllBatchPendingListDataParamsType,
  GetAllBatchPendingListDataType,
} from "../../../../types/portal/batch";
import { countParPageSerialNumber } from "../../../../utils/number";
import { addKeyInArray } from "../../../../utils/utils";

export default function BatchPendingList() {
  const [selectedData, setSelectedData] = useState<string[]>([]);
  const [comment, setComment] = useState("");
  const { id, walletId } = useParams();
  const navigate = useNavigate();
  const {
    page,
    limit,
    handlePagination,
    handleFilter,
    handleLimit,
    filter,
    keyword,
    handleSearch,
  } = useTable<GetAllBatchPendingListDataParamsType>();
  const {
    open: openConfirmRejectModal,
    handleOpen: handleConfirmRejectOpen,
    handleClose: handleConfirmRejectClose,
  } = useModal<{ id: number }, "CONFIRM_REJECT">();
  const { open, handleOpen, handleClose } = useModal<
    { id: number },
    "CONFIRM_FOR_APPROVAL"
  >();
  const {
    open: openSuccessModal,
    handleOpen: handleSuccessOpen,
    handleClose: handleSuccessClose,
  } = useModal<undefined, "SUCCESS">();

  const roleCheck = localStorage.getItem("project_role");
  const productId = localStorage.getItem("product_id");
  const { user } = useAppSelector((state) => state.auth);

  const {
    data: getSingleUserWalletRoleData,
    isError: getSingleUserWalletRoleIsError,
    error: getSingleUserWalletRoleError,
    isLoading: getSingleUserWalletRoleIsLoading,
  } = useGetSingleUserWalletRoleQuery(
    {
      walletId: walletId ? Number(walletId) : undefined,
      userId: user?.data?.id,
    },
    { skip: !walletId || !user?.data?.id }
  );

  const {
    data: allBatchPendingData,
    isLoading: allBatchPendingIsLoading,
    isError: allBatchPendingIsError,
    error: allBatchPendingError,
  } = useGetAllBatchPendingListQuery({
    params: {
      ...filter,
      search: keyword,
      skip: undefined,
      companyId: user?.data?.company_id,
      projectId: Number(id),
      page,
    },
  });

  const [
    pendingBatchBulkAction,
    {
      isLoading: pendingBatchBulkActionIsLoading,
      isError: pendingBatchBulkActionIsError,
      error: pendingBatchBulkActionError,
      isSuccess: pendingBatchBulkActionIsSuccess,
    },
  ] = usePendingBatchBulkActionMutation();

  useError(
    allBatchPendingIsError,
    allBatchPendingError,
    "Get all batch pending list fail"
  );
  useError(
    pendingBatchBulkActionIsError,
    pendingBatchBulkActionError,
    "Approve or Reject action fail"
  );

  useError(
    getSingleUserWalletRoleIsError,
    getSingleUserWalletRoleError,
    "Get single user wallet role failed"
  );

  useEffect(() => {
    if (getSingleUserWalletRoleIsError) {
      setTimeout(() => {
        navigate("/admin/salary-disbursement/batch");
      }, 1500);
    }
  }, [getSingleUserWalletRoleIsError, navigate]);

  const buttonClass =
    "w-7 h-7 bg-white rounded-full border justify-center items-center inline-flex cursor-pointer select-none";

  const columns: TableProps<GetAllBatchPendingListDataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: <div className="whitespace-nowrap !w-[120px]">Batch Name</div>,
      dataIndex: "batchName",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <div className="whitespace-nowrap !w-[120px]">Batch No.</div>,
      dataIndex: "batchNo",
      render: (val) => (val ? val : "N/A"),
    },
    // {
    //   title: <span className="whitespace-nowrap">Import Date</span>,
    //   dataIndex: "created_at",
    //   render: (val: string) =>
    //     val ? (
    //       <>
    //         {formatDate(val)}, {formatTime(val)}
    //       </>
    //     ) : (
    //       "N/A"
    //     ),
    // },
    {
      title: <span className="whitespace-nowrap">Number of Employees</span>,
      align: "center",
      dataIndex: "numberOfEmployees",
      render: (val) => (val ? val : 0),
    },
    {
      title: <span className="whitespace-nowrap !w-[250px]">Amount (BDT)</span>,
      align: "center",
      dataIndex: "totalAmount",
      render: (val: string | number) => (
        <>
          ৳{" "}
          {val
            ? Number(val)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "0"}
        </>
      ),
    },
    // {
    //   title: <span className="whitespace-nowrap">Disbursed Amount (BDT)</span>,
    //   align: "center",
    //   dataIndex: "totalDisbursed",
    //   render: (val: string | number) => (
    //     <>
    //       ৳{" "}
    //       {val
    //         ? Number(val)
    //             .toFixed(2)
    //             .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //         : "0"}
    //     </>
    //   ),
    // },
    // {
    //   title: <span className="whitespace-nowrap">Pending Amount (BDT)</span>,
    //   align: "center",
    //   dataIndex: "totalPending",
    //   render: (val: string | number) => (
    //     <>
    //       ৳{" "}
    //       {val
    //         ? Number(val)
    //             .toFixed(2)
    //             .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    //         : "0"}
    //     </>
    //   ),
    // },
    {
      title: <span className="whitespace-nowrap">Disbursement Type</span>,
      align: "center",
      dataIndex: "disbursement_type",
      render: (val: string) =>
        val ? val.charAt(0).toUpperCase() + val.slice(1).toLowerCase() : "N/A",
    },
    {
      title: <span className="whitespace-nowrap">Created At</span>,
      align: "center",
      dataIndex: "created_at",
      render: (val: string) =>
        val ? (
          <>
            {formatDate(val)}, {formatTime(val)}
          </>
        ) : (
          "N/A"
        ),
    },
    // {
    //   title: <span className="whitespace-nowrap">Updated At</span>,
    //   align: "center",
    //   dataIndex: "updated_at",
    //   render: (val: string) =>
    //     val ? (
    //       <>
    //         {formatDate(val)}, {formatTime(val)}
    //       </>
    //     ) : (
    //       "N/A"
    //     ),
    // },
    // {
    //   title: <div className="whitespace-nowrap !w-[110px]">Status</div>,
    //   dataIndex: "batchStatus",
    //   align: "center",
    //   render: (val) => (
    //     <span
    //       className={`px-2 py-1 rounded text-xs font-medium ${
    //         val === "Complete"
    //           ? "bg-green-100 text-green-700"
    //           : "bg-yellow-100 text-yellow-700"
    //       }`}
    //     >
    //       {/* {val.charAt(0).toUpperCase() + val.slice(1)} */}
    //     </span>
    //   ),
    // },
    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (val, record: any) => (
        <div className="flex justify-center items-center gap-3">
          <Tooltip placement="top" title="Reject">
            <span
              onClick={() =>
                handleConfirmRejectOpen({
                  type: "CONFIRM_REJECT",
                  data: record,
                })
              }
              className={`${buttonClass} border-[#ffc5c1] text-dark-highlight`}
            >
              <CloseIcon />
            </span>
          </Tooltip>

          <Tooltip placement="top" title="Approve">
            <span
              onClick={() => handleOpen({ type: "CONFIRM", data: record })}
              className={`${buttonClass} border-[#8fe6b7] text-complete`}
            >
              <DoubleCheckIcon />
            </span>
          </Tooltip>
        </div>
      ),
    },
  ];

  const handleOkay = () => {
    handleConfirmRejectClose();
    handleSuccessClose();
    handleClose();
  };

  const handleBatchReject = (value: string) => {
    if (selectedData && selectedData.length > 0) {
      const newData = {
        pendingBatchIds: selectedData,
        comment: value,
        projectId: Number(productId),
        action: "reject",
      };

      pendingBatchBulkAction({
        data: newData,
      });
    }

    if (openConfirmRejectModal?.data?.id) {
      const newData = {
        pendingBatchIds: [openConfirmRejectModal?.data?.id],
        comment: value,
        projectId: Number(productId),
        action: "reject",
      };

      pendingBatchBulkAction({
        data: newData,
      });
    }
  };

  const handleSendToApprove = () => {
    if (selectedData && selectedData.length > 0) {
      const newData = {
        pendingBatchIds: selectedData,
        comment: comment,
        projectId: Number(productId),
        action: "approve",
      };

      pendingBatchBulkAction({
        data: newData,
      });
    }

    if (open?.data?.id) {
      const newData = {
        pendingBatchIds: [open?.data?.id],
        comment: comment,
        projectId: Number(productId),
        action: "approve",
      };

      pendingBatchBulkAction({
        data: newData,
      });
    }
  };

  const getModalTitle = () => {
    if (open?.type === "CONFIRM") return "Batch list Successfully Added!";
    if (openConfirmRejectModal.type === "CONFIRM_REJECT")
      return "Pending Batch Rejected Successfully!";
    return "";
  };

  useEffect(() => {
    if (pendingBatchBulkActionIsSuccess) {
      handleSuccessOpen({ type: "SUCCESS" });
      setSelectedData([]);
      setComment("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingBatchBulkActionIsSuccess]);

  return (
    <>
      {openSuccessModal.type === "SUCCESS" && (
        <SuccessModal
          open={openSuccessModal?.open}
          handleClose={handleSuccessClose}
          handleOkay={handleOkay}
          data={openSuccessModal?.data}
          title={getModalTitle()}
        />
      )}

      {openConfirmRejectModal.type === "CONFIRM_REJECT" && (
        <ConfirmActionModal
          title="Are you sure you want to reject this batch?"
          handleClose={handleConfirmRejectClose}
          open={openConfirmRejectModal.open}
          handleBatchRejectSubmit={(val) => handleBatchReject(String(val))}
          isLoading={pendingBatchBulkActionIsLoading}
          isReject
        />
      )}

      {open?.type === "CONFIRM" && (
        <ConfirmModalLayout
          title="Send to Batch List"
          subTitle="Are you sure you want to send batch list?"
          buttonName="Send"
          handleButton={handleSendToApprove}
          open={open?.open}
          handleClose={handleClose}
          action
          buttonBgDeep
          loading={pendingBatchBulkActionIsLoading}
        >
          <div>
            <div className="mb-2 text-[#5E718D]">Comment</div>
            <Input
              placeholder="Enter comment"
              onChange={(e) => setComment(e.target.value)}
            />
          </div>
        </ConfirmModalLayout>
      )}

      <SidebarLayout
        title="Batch Pending List"
        backLink={`/admin/salary-disbursement/batch`}
      >
        {getSingleUserWalletRoleIsLoading ? (
          <Loader />
        ) : (
          <>
            <Card className="mb-4">
              <p className="text-blue-500 text-2xl font-medium leading-tight flex items-center gap-3">
                <div>Role: {"Maker"}</div>
              </p>
            </Card>

            <CustomTable
              loading={
                allBatchPendingIsLoading || getSingleUserWalletRoleIsLoading
              }
              limit={limit}
              page={page}
              columns={columns}
              total={allBatchPendingData?.data?.total || 0}
              dataSource={addKeyInArray(allBatchPendingData?.data?.data)}
              handleLimit={handleLimit}
              handlePagination={handlePagination}
              rowSelection={{
                type: "checkbox",
                selectedRowKeys: selectedData,
                onChange: (key) => {
                  setSelectedData(key as string[]);
                },
                getCheckboxProps: (record) => {
                  return {
                    disabled: record?.status === "invited",
                  };
                },
                columnWidth: 40,
              }}
              filterSection={
                <>
                  <Input
                    suffix={<SearchIcon />}
                    placeholder="Batch Name"
                    style={{ width: 205 }}
                    allowClear
                    onChange={handleSearch}
                  />

                  <Button
                    onClick={() =>
                      handleConfirmRejectOpen({ type: "CONFIRM_REJECT" })
                    }
                    // loading={pendingBatchBulkActionIsLoading}
                    disabled={selectedData?.length === 0}
                    className="cursor-pointer h-9 px-3.5 py-2 !bg-red-50 rounded-md outline outline-1 outline-offset-[-1px] outline-red-300 inline-flex justify-center items-center gap-2.5"
                  >
                    <span className="text-red-500 text-sm font-semibold">
                      Reject
                    </span>
                  </Button>

                  <Button
                    className="middle-  min-w-[150px] !text-[#ffffff]"
                    type="primary"
                    disabled={selectedData?.length === 0}
                    onClick={() => handleOpen({ type: "CONFIRM" })}
                    // loading={pendingBatchBulkActionIsLoading}
                  >
                    Approve
                  </Button>
                </>
              }
            />
          </>
        )}
      </SidebarLayout>
    </>
  );
}
